// Maps a DCC software's display name (from the SSR `dccSoftwares` list) to the
// plugin key the distribution API uses in `GET /api/generator/dcc-plugins`.
// The API keys are derived from GitHub release asset filenames
// (`aistudio-plugin-v<version>-<software>.<ext>`). The documented key for
// 3ds Max is `max`; confirm against the live endpoint if it ever ships as
// `3ds-max` and adjust this map accordingly.
const PLUGIN_KEYS_BY_NAME = {
  Blender: 'blender',
  '3ds Max': 'max',
  Maya: 'maya',
  Unity: 'unity',
  Unreal: 'unreal',
}

export const getPluginKey = (name) => PLUGIN_KEYS_BY_NAME[name] || name.toLowerCase()

// Plugin installers are served only from production, so downloads are pinned to
// cgtrader.com regardless of the current environment (dev/staging still hand
// out the real prod installers).
const DCC_PLUGINS_DOWNLOAD_BASE = 'https://www.cgtrader.com/api/generator/dcc-plugins'

export const getDccPluginDownloadUrl = (pluginKey) =>
  `${DCC_PLUGINS_DOWNLOAD_BASE}/${encodeURIComponent(pluginKey)}/download`
